module.exports = __webpack_public_path__ + "static/media/dia.15cb7e25.jpg";